import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { GeoJSON } from 'react-leaflet';
import { currentStateForSpot, checkUserLoggedIn } from './../../utils';
import styles from './../../styles/parkingSpots';

class ParkingSpotsLayer extends Component {

  constructor(props) {
    super(props);
    this.onEachFeature = this.onEachFeature.bind(this);
    this.parkingSpotStyle = this.parkingSpotStyle.bind(this);
  }

  parkingSpotStyle(feature) {
    const { spotid } = feature.properties;
    const { spotId:holdSpotId } = this.props;
    const currentState = currentStateForSpot(spotid);

    const { status } = currentState;
    const isOpenSpot = status === 'OPEN';

    if (spotid === holdSpotId) {
      return (status === 'OPEN') ? styles.selectedAvailableSpot : styles.selectedUnavailableSpot;
    }
    if (isOpenSpot) {
      return styles.availableSpot;
    }
    return styles.reservedSpot;
  }

  onEachFeature(feature, layer) {
  }

  render() {
    const {data} = this.props;
    return (
      <GeoJSON key={Math.random()}
               data={data}
               onEachFeature={this.onEachFeature}
               style={this.parkingSpotStyle}
               bubblingMouseEvents={false}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const { list:parkingSpotsList } = state.parkingSpots;
  const { reservedSpots } = state.userAccommodationInfo;
  return {
    parkingSpotsList,
    reservedSpots,
    isUserLoggedIn: checkUserLoggedIn(state.user),
  };
};

export default connect(mapStateToProps)(ParkingSpotsLayer);



// WEBPACK FOOTER //
// ./src/containers/SpotMap/ParkingSpotsLayer.js